import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { Button } from "rhombus-react";

import { getAiVersionGenerationEnabled } from "selectors/AI";
import { GENERATE_VERSIONS } from "widgets/grid/cells/CreativeActionLists/VersionActions";

import "./GenerateVersionsButton.css";

export default function GenerateVersionsButton({ isDisabled }){
	const creative = useSelector(state => state.creativeDetails);
	const contentFeedUrl = creative?.contentFeedUrl;
	const isAiVersionGenerationEnabled = useSelector(getAiVersionGenerationEnabled);
	const shouldDisplay = GENERATE_VERSIONS.shouldDisplay({
		dependentValues: creative,
		isAiVersionGenerationEnabled,
	});

	const creativeId = creative.id;
	const { pathname } = useLocation();
	const linkClass = (isDisabled || !!contentFeedUrl) ? "is-disabled" : "";

	if(!shouldDisplay){
		return null;
	}

	return (
		<Link to={`${pathname}modal/generate-versions/?creativeIds=${creativeId}`} className={`generate-versions-button ${linkClass}`}>
			<Button key="generate-versions" icon="fas fa-magic" style="block" disabled={isDisabled || !!contentFeedUrl}>Generate Versions</Button>
		</Link>
	);
}

GenerateVersionsButton.propTypes = {
	isDisabled: PropTypes.bool,
};
GenerateVersionsButton.displayName = "GenerateVersionsButton";
